import { render } from "./Roles.vue?vue&type=template&id=3c866a22&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"

import "./Roles.vue?vue&type=style&index=0&id=3c866a22&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c866a22"]])

export default __exports__